import { Axios } from '@moniebook-web/utils';

import { HOST_API_URL } from '@/shared/constants';

export const endGhostSession = async (sessionId: string): Promise<void> => {
    await Axios.post(HOST_API_URL.GHOST_SESSION_END(sessionId));
};
